;
(function ( $, window ) {
    window.showOverlay = function( popupId ) {
        var focusedElementBeforeModal = document.activeElement
        var $overlay = $('<div class="reveal-modal-bg fade in" style="display: block;display: block"></div>');
        var $popup = $('#' + popupId);
        $popup.css("top", Math.max(50, (($(window).height() - $popup.outerHeight()) / 2) + $(window).scrollTop()) + "px");    
        var $closeButton = $('.close-reveal-modal, .close', $popup);
        var removeOverlays = function() {
          $closeButton.off('click');
          $overlay.remove();
          $popup.hide();
          $(document).trigger('sn.overlay.close', popupId);
        };
        $overlay.on('click', function() {
          removeOverlays();
        });
        $closeButton.on('click', function() {
          removeOverlays();
          focusedElementBeforeModal.focus();
        });
        $overlay.insertBefore($popup);
        $(document).trigger('sn.overlay.open', popupId);
        $popup.show();
    }
})( jQuery, window );